import { render, staticRenderFns } from "./Index-Settings.vue?vue&type=template&id=0df1af56&scoped=true&"
import script from "./Index-Settings.vue?vue&type=script&lang=js&"
export * from "./Index-Settings.vue?vue&type=script&lang=js&"
import style0 from "./Index-Settings.vue?vue&type=style&index=0&id=0df1af56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1af56",
  null
  
)

export default component.exports